// extracted by mini-css-extract-plugin
export var clickable = "column-grid-module--clickable--eM+8U";
export var grid = "column-grid-module--grid--6jSLe";
export var myCollaborateMasonryGridColumn = "column-grid-module--myCollaborateMasonryGridColumn--IUfgk";
export var myMasonryGrid = "column-grid-module--myMasonryGrid--7lf74";
export var myMasonryGridColumn = "column-grid-module--myMasonryGridColumn--7GiAF";
export var srOnly = "column-grid-module--srOnly--L4Eu6";